import React from "react";
import { Context } from "./Calendar.context.js";
var useCalendarContext = function () { return React.useContext(Context); };
export default useCalendarContext;
